module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [(_vm.swiperlist.length > 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper_con",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l((_vm.swiperlist), function(item, index) {
    return _c('swiper-slide', {
      key: item.id
    }, [_c('img', {
      attrs: {
        "src": item.pic_url.replace('x-oss-process=style', '')
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        return _vm.prevFun()
      }
    },
    slot: "button-prev"
  }, [_c('div', {
    staticClass: "but_direct"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        return _vm.nextFun()
      }
    },
    slot: "button-next"
  }, [_c('div', {
    staticClass: "but_direct"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, _vm._l((_vm.list), function(month) {
    return (month.list.length > 0) ? _c('div', [(month.list.length > 0) ? _c('div', {
      staticClass: "sai-items-wrap"
    }, _vm._l((month.list), function(item) {
      return _c('div', {
        staticClass: "sai-itmes-li"
      }, [_c('div', {
        staticClass: "train-items-top show-two-row items-top1",
        style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
      }, [_c('div', {
        staticClass: "sai-type-tip offline",
        staticStyle: {
          "visibility": "hidden"
        }
      }, [_vm._v(_vm._s(_vm.$T('线下')))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(_vm.$T('南京')))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
        staticClass: "sai-info-box",
        staticStyle: {
          "flex": "1"
        }
      }, [_c('p', {
        staticClass: "sai-title show-two-row"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      }, [(item.status == 1) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v(_vm._s(_vm.$T('未开始')))]) : (item.status == 2) ? _c('el-tag', {
        attrs: {
          "type": "success"
        }
      }, [_vm._v(_vm._s(_vm.$T('正在报名')))]) : (item.status == 3) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v(_vm._s(_vm.$T('报名结束')))]) : (item.status == 4) ? _c('el-tag', {
        attrs: {
          "type": "success"
        }
      }, [_vm._v(_vm._s(_vm.$T('正在比赛')))]) : (item.status == 5) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v(_vm._s(_vm.$T('已结束')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      })]), _vm._v(" "), _c('el-row', [(item.status < 3) ? _c('el-button', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'ISaiApplyFormStep1',
            query: {
              saiqu_id: item.id
            }
          }),
          expression: "{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
        }],
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(_vm._s(_vm.$T('报名')) + "\n            ")]) : _vm._e()], 1)], 1)
    }), 0) : _vm._e()]) : _vm._e()
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5ec560c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiDateList.vue
// module id = 1521
// module chunks = 0